import { render, staticRenderFns } from "./ForumUserInfo.vue?vue&type=template&id=a01454a0&scoped=true&"
import script from "./ForumUserInfo.vue?vue&type=script&lang=js&"
export * from "./ForumUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./ForumUserInfo.vue?vue&type=style&index=0&id=a01454a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01454a0",
  null
  
)

export default component.exports